module.exports = __webpack_public_path__ + "static/media/previous-arrow.320fc3ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/previous-arrow.png
// module id = 436
// module chunks = 0